import React, { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";
// config
import configData from "../../../config/config.json";
// component
import ActiveSwitch from "../active-switch/ActiveSwitch";

const InformationStep1 = (props) => {
  const [dataCome, setDataCome] = useState();

  const [data, setData] = useState({
    EnTitle: "",
    ApproveStatus: "",
    Photo: "",
  });

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    setDataCome(false);
    if (props.render) {
      axios
        .get(
          configData.API_DOMAIN + `/api/v1/Businesses/${getCookie("BizUuid")}`,
          {
            headers: header,
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;
            setDataCome(true);
            setData({
              EnTitle: data.enTitle,
              ApproveStatus: data.approveStatus,
              IsApprove: data.isApproved,
              IsDisable: data.isDisable,
              Photo: data.photoPath,
            });
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [props.render]);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <>
      <div className="part_one_info">
        {dataCome ? (
          <>
            <div className="">
              <img className="img_part_one" src={data.Photo} alt="imgStep1" />
            </div>
            <div className="mt_39">
              <span className="span_part_one ">
                عنوان کسب‌و‌کار: {data.EnTitle}
              </span>
              <p className="span_part_one">
                وضعیت کسب‌وکار:{" "}
                <span className="color_span_info"> {data.ApproveStatus}</span>
              </p>
              {(data.IsApprove ||
                data.ApproveStatus === " غیر فعال شده توسط صاحب کسب و کار") && (
                <ActiveSwitch
                  data={data}
                  setData={setData}
                  setDataCome={setDataCome}
                />
              )}
            </div>
          </>
        ) : (
          <>
            <Skeleton
              className="img_part_one"
              variant="rectangular"
              height={123}
              width={123}
              animation="wave"
            />
            <div className="mt_39 text-center">
              <Skeleton
                className="span_part_one mt-2 mx-auto mx-md-0"
                variant="text"
                width={200}
                height={14}
                animation="wave"
              />{" "}
              <Skeleton
                className="span_part_one mt-2 mx-auto mx-md-0"
                variant="text"
                width={200}
                height={14}
                animation="wave"
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InformationStep1;
